<template>
	<ModalGenericModal
		:title="$t('cartTimeoutTitle')"
		container-class="max-w-sm cartExpiredPopupComponent"
		ref="modal">
		<div class="pt-6 pb-3 px-6 relative z-30 text-popup-text bg-popup-bg border-x-2 border-popup-border">
			<p>{{ $t("cartTimeoutBody") }}</p>
		</div>

		<div class="flex justify-center gap-8 py-4 bg-popup-bg border-b-2 border-x-2 rounded-b-lg border-popup-border">
			<ButtonModalClose
				:label="$t('close')"
				@click="closeModal" />
		</div>
	</ModalGenericModal>
</template>

<script setup>
	import { useNuxtApp } from "#app"
	import { onMounted, onUnmounted } from "vue"
	import { SHOW_CART_TIMEOUT_EXPIRED } from "assets/events/cartTimeout"
	import { useRefsStore } from "~/stores/RefsStore"

	const { $eventBus } = useNuxtApp()
	const refsStore = useRefsStore()
	const modal = ref(null)

	onMounted(() => {
		refsStore.setCartTimeoutExpiredPopupRef(modal.value)

		$eventBus.$on(SHOW_CART_TIMEOUT_EXPIRED, () => {
			openModal()
		})
	})

	onUnmounted(() => {
		$eventBus.$off(SHOW_CART_TIMEOUT_EXPIRED)
	})

	const openModal = () => refsStore.cartTimeoutExpiredPopupRef.openModal()

	const closeModal = () => refsStore.cartTimeoutExpiredPopupRef.closeModal()
</script>
